import { qdfoodApi } from './constant';
import { INews } from '@type/news';
import { IResponse } from '@type/response';

export const NEWS_API = {
  urlGetNews: `/news/web-user`,
  urlGetNewsBgSlug: (id: string) => `/news/${id}`,
};

export default class newsApi {
  static getNews(params = {}) {
    return qdfoodApi().get<IResponse<INews>>(NEWS_API.urlGetNews, {
      params,
    });
  }
  static getDetail(id: string) {
    return qdfoodApi().get<INews>(NEWS_API.urlGetNewsBgSlug(id), {
      params: {
        type: 'slug',
      },
    });
  }
}
